import React, { useEffect } from "react";
import InnerHeader from "component/shared/innerheader/InnerHeader";
import { useIntl } from "react-intl";
import "./data.scss";
import CardData from "./components/CardData";
// import Card from "component/about/laws/components/Card";
import useSWR from "swr";
import { END_POINTS } from "constants/APIConstant";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import { API_BASE_URL } from "configs/AppConfig";
import { staticColorArray } from "constants/ColorConstant";
import ReactGA from "react-ga4";

function Data() {
  const intl = useIntl();

  const imgTest = process.env.PUBLIC_URL + "image/info1.png";
  // const imgTest2 = process.env.PUBLIC_URL + 'image/info2.png';
  // const imgTest3 = process.env.PUBLIC_URL + 'image/info3.png';
  // const prim = process.env.PUBLIC_URL + "image/pirm.png";

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  ReactGA.initialize(END_POINTS.TRACKING_ID)

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/data", title: "Data Page" });
  }, []);

  // const getRandomColor = () => {
  //   const colors = [
  //     "var(--second-color)",
  //     "var(--main-color)",
  //     "#FF5568",
  //     "#54AA63",
  //   ];

  //   const randomIndex = Math.floor(Math.random() * colors.length);
  //   return colors[randomIndex];
  // };

  const subjectsFetching = useSWR({
    url: END_POINTS.SUBJECTS_WITH_DATA,
  });

  const renderDataCard = () => {
    const subjectData =
      subjectsFetching.error ||
      subjectsFetching.isLoading ||
      subjectsFetching.data === undefined
        ? []
        : subjectsFetching.data.data;
    const rendering =
      Object.keys(subjectData).length > 0 ? (
        <>
          {subjectData.map(
            ({ id, title, image, subSubjects, subjectTranslations }, i) => (
              <CardData
                key={i}
                title={title}
                id={id}
                color={staticColorArray[id]}
                imgCard={image ? `${API_BASE_URL}/${image} ` : imgTest}
                subSubjects={subSubjects}
                subjectTranslations={subjectTranslations}
              />
            )
          )}
        </>
      ) : (
        <DataNotFound />
      );
    return rendering;
  };

  return (
    <ContentLoading
      isLoading={
        // subjectsFetching.error ||
        subjectsFetching.isLoading
      }
    >
      <div className="data">
        <InnerHeader
          breadcrumb={[
            { title: intl.formatMessage({ id: "data" }), clickClass: true },
          ]}
          title={intl.formatMessage({ id: "data-title" })}
        />
        <div className="container my-5">
          <div className="row gx-0 gy-4">{renderDataCard()}</div>
          {/* <div className="row gx-sm-3 gx-md-0 gy-4 d-flex justify-content-sm-start justify-content-center align-items-end mt-1">
            <div className="col-xl-4 col-lg-5 col-md-6 col-sm-8 col-11">
              <Card
                // url={"https://www.capmas.gov.eg/Pages/ExternalTrade.aspx"}
                url={"../external-trade"}
                isInternal={true}
                title={intl.formatMessage({ id: "external-trade" })}
                isPDF={false}
                description={intl.formatMessage({
                  id: "browse-external-trade",
                })}
              />
            </div>
            <div className="col-xl-8 col-lg-7 col-md-6 col-sm-4">
              <div className="img-data-fixed">
                <img src={prim} alt="img-data-fixed" />
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </ContentLoading>
  );
}

export default Data;
